module.exports = __webpack_public_path__ + "img/step05.d8af87b2.png";